import { createSlice } from "@reduxjs/toolkit";
import { fileUpload } from "../../api/general/uploadFile";

export const uploadFiles = createSlice({
  name: "upload",
  initialState: {
    request: false,
    messageTitle: "",
    message: "",
    outcome: "pending",
  },
  reducers: {
    showError(state, action) {
      state.request = false;
      state.outcome = "fail";
      state.messageTitle = action?.payload?.title;
      state.message = action?.payload?.message;
    },
    showSuccess(state, action) {
      state.request = false;
      state.outcome = "success";
      state.messageTitle = action?.payload?.title;
      state.message = action?.payload?.message;
    },
    cancelError(state) {
      state.request = false;
      state.outcome = "pending";
      state.message = "";
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fileUpload.pending, (state, action) => {
        state.request = true;
      })
      .addCase(fileUpload.fulfilled, (state, action) => {
        state.request = false;
        state.messageTitle = "Success";
        state.outcome = "success";
        state.message = "";
      })
      .addCase(fileUpload.rejected, (state, action) => {
        const payload = action.payload as { message?: string } | undefined;
        state.request = false;
        state.outcome = "fail";
        state.messageTitle = "Error";
        state.message =
          payload?.message || "An error occurred while uploading the file.";
      });
  },
});

export const { cancelError, showError, showSuccess } = uploadFiles.actions;

export default uploadFiles.reducer;
